import { tracked } from '@glimmer/tracking';

import {
  DEFAULT_AGE_RANGES,
  MEDIAN_NATIONAL_TUITION,
  CURRENT_DATA_YEAR,
  FORECAST_DATA_YEAR,
} from '../constants';

export default class Report {
  @tracked driveTime = null;
  @tracked sex = null;
  @tracked tuition = null;
  @tracked year = null;
  @tracked lat = null;
  @tracked long = null;
  @tracked address = null;
  @tracked ageRanges = null;

  @tracked data = null;
  @tracked forecastData = null;

  constructor({
    driveTime,
    sex,
    tuition,
    year,
    lat,
    long,
    address,
    ageRanges,
  }) {
    this.driveTime = driveTime;
    this.sex = sex ?? 'all';
    this.tuition = tuition ?? MEDIAN_NATIONAL_TUITION;
    this.year = year ?? CURRENT_DATA_YEAR;
    this.lat = lat;
    this.long = long;
    this.address = address;
    this.ageRanges = ageRanges ?? DEFAULT_AGE_RANGES;
  }

  get hasData() {
    return this.data && this.forecastData;
  }

  get isForecasting() {
    return this.year == FORECAST_DATA_YEAR;
  }

  /* Used to generate the params for the report API request */
  get params() {
    let report = this;
    return {
      lat: report.lat,
      long: report.long,
      address: report.address,
      age_ranges: report.ageRanges, // eslint-disable-line camelcase
      tuition: report.tuition,
      sex: report.sex,
      drive_time: report.driveTime, // eslint-disable-line camelcase
      year: report.year,
    };
  }

  paramsMatch(params) {
    return (
      this.lat === params.lat &&
      this.long === params.long &&
      this.address === params.address &&
      rangeArrayCompare(this.ageRanges, params.ageRanges) &&
      this.tuition === params.tuition &&
      this.sex === params.sex &&
      this.driveTime === params.driveTime &&
      this.year === params.year
    );
  }
}

function rangeArrayCompare(a, b) {
  return (
    a &&
    b &&
    a.length === b.length &&
    a.every((value) =>
      b.find((item) => value[0] === item[0] && value[1] === item[1]),
    )
  );
}
